module.exports = __webpack_public_path__ + "img/idc_datacenter_pic05.0defb30a.jpg";